import { makeObservable, observable, action, reaction } from 'mobx';
import { WorksheetChangeDto } from '../types';
import { InputBaseModel } from '../models';
import { Disposer } from '../../custom_shared/misc';
import { AccountingStatementService } from '../services';
import { InstanceUtils } from '../misc';
import SessionStore from './SessionStore';

export default class WorksheetsChangesStore extends Disposer {
    isChangesModalVisible: boolean = false;

    worksheetsChanges: Record<string, WorksheetChangeDto[]> = {};

    constructor(
        private readonly sessionStore: SessionStore,
        private readonly service: AccountingStatementService
    ) {
        super();

        makeObservable(this, {
            isChangesModalVisible: observable,
            worksheetsChanges: observable,
            setIsChangesModalVisible: action,
            setWorksheetsChanges: action
        });

        this.reactions.push(
            reaction(
                () => this.sessionStore.response,
                () => {
                    if (!this.sessionStore.inProgress) {
                        this.getWorksheetsChanges();
                    }
                }
            )
        );
    }

    setIsChangesModalVisible(isChangesModalVisible: boolean) {
        this.isChangesModalVisible = isChangesModalVisible;
    }

    setWorksheetsChanges(worksheetsChanges: Record<string, WorksheetChangeDto[]>) {
        this.worksheetsChanges = worksheetsChanges;
    }

    async getWorksheetsChanges() {
        try {
            const response = await this.service.getWorksheetsChanges(
                this.sessionStore.sessionExtension,
                this.sessionStore.sessionId
            );

            if (response.isOk()) {
                response.map(changes => this.setWorksheetsChanges(changes));
            }
        } catch (error) {
            console.error(error);
        }
    }

    async recordPendingInputChange(input: InputBaseModel) {
        try {
            const response = await this.service.recordWorksheetInputChange(
                this.sessionStore.sessionExtension,
                this.sessionStore.sessionId,
                {
                    worksheetId: input.worksheetId,
                    nodeId: input.nodeId,
                    input: input.dto,
                    sources: InstanceUtils.isInputWithSource(input) ? input.sourceProvider.sourceData : []
                }
            );

            if (response.isOk()) {
                response.map(changes => this.setWorksheetsChanges(changes));
            }
        } catch (error) {
            console.error(error);
        }
    }

    dispose() {
        this.cleanupPendingChanges();
        this.disposeReactions();
    }

    private async cleanupPendingChanges() {
        try {
            await this.service.cleanupPendingWorksheetChanges(
                this.sessionStore.sessionExtension,
                this.sessionStore.sessionId
            );
        } catch (error) {
            console.error(error);
        }
    }
}
